<script type="text/ecmascript-6">
    import TileQuestion from "./mixin/TileQuestion.vue";

    export default {
        mixins: [
            TileQuestion
        ],
        props: {
            title: {
                default(){
                    return 'Glass Design';
                }
            },
            slab: {
                required: true,
            },
            laminatedGlass: {
                required: true,
            },
            doorRange: {
                required: true,
            },
            component_id: {
                default(){
                    return 'glass_design';
                }
            },
            collection: {
                required: false,
                default() {
                    return '';
                }
            },
            argonGlass: {
                required: false,
                default() {
                    return 27;  // 27 is No (collection table)
                }
            }
        },
        computed: {
            thumbURL(){
                return '/thumb/glass/';
            },
            passed_filter(){
                return this.variable_ready(this.slab, this.laminatedGlass, this.doorRange, this.collection,  this.argonGlass);
            },
            url(){
                return '/api/options/' + this.fabricator + '/glass-design?laminated=' + this.laminatedGlass + '&slab=' + this.slab + '&door_range=' + this.doorRange + '&collection=' + this.collection + '&argon_glass=' + this.argonGlass;
            },
            cache_key(){
                return '_' + this.slab + '_' + this.laminatedGlass + '_' + this.doorRange + '_' + this.collection + '_' + this.argonGlass;
            },
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
